import { Link } from 'react-router'

import { PublicLayout } from '@/components/PublicLayout'
import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  return (
    <PublicLayout>
      <div className="space-y-7">
        <p className="font-mono text-sm text-primary">404</p>
        <div className="space-y-3">
          <h1 className="text-3xl font-semibold tracking-[-0.03em] text-balance text-foreground">
            There is nothing at this address.
          </h1>
          <p className="max-w-prose text-[0.9375rem] leading-relaxed text-pretty text-muted-foreground">
            The console lives under <code className="font-mono text-foreground">/app</code>.
            If you followed a verification link, check that it kept its{' '}
            <code className="font-mono text-foreground">?token=</code> query string — some
            mail clients truncate long URLs.
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          <Button asChild>
            <Link to="/app">Go to the console</Link>
          </Button>
          <Button variant="ghost" asChild>
            <Link to="/">Back to the overview</Link>
          </Button>
        </div>
      </div>
    </PublicLayout>
  )
}
